import { Component } from '@angular/core';
import {MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {ModalHeaderComponent} from "../../../layout/modal-header/modal-header.component";
import {WorkspaceService} from "../../../services/workspace.service";
import {RouterLink} from "@angular/router";
import {CommonModalsService} from "../../../services/modals/common-modals.service";

@Component({
    selector: 'app-info-built-in-integrations-not-allowed',
    imports: [
        ModalHeaderComponent,
        MatDialogContent,
        RouterLink
    ],
    templateUrl: './info-built-in-integrations-not-allowed.component.html',
    styleUrl: './info-built-in-integrations-not-allowed.component.scss'
})
export class InfoBuiltInIntegrationsNotAllowedComponent {
  constructor(
    public dialogRef: MatDialogRef<InfoBuiltInIntegrationsNotAllowedComponent>,
    public workspaceSvc: WorkspaceService,
    public commonModalSvc: CommonModalsService
  ) { }
}
